import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const StrategyPage = lazy(() => import('../pages/strategy/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const InvestorsPage = lazy(() => import('../pages/investors/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/strategy',
    element: <StrategyPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/investors',
    element: <InvestorsPage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;